/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ShadowMCPInventoryUser,
  ShadowMCPInventoryUser$inboundSchema,
} from "./shadowmcpinventoryuser.js";

export type ListShadowMCPInventoryUsersResult = {
  /**
   * Cursor for the next page of results.
   */
  nextCursor?: string | undefined;
  users: Array<ShadowMCPInventoryUser>;
};

/** @internal */
export const ListShadowMCPInventoryUsersResult$inboundSchema: z.ZodMiniType<
  ListShadowMCPInventoryUsersResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    users: z.array(ShadowMCPInventoryUser$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listShadowMCPInventoryUsersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListShadowMCPInventoryUsersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListShadowMCPInventoryUsersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListShadowMCPInventoryUsersResult' from JSON`,
  );
}
